const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001').replace(/\/+$/, ''); // Remove trailing slashes

export { API_BASE_URL };